import { action } from 'satcheljs';

export interface Popout_OnRemoveProjectionActionMessage {
    tabId: string;
    window: Window;
}
const onRemoveProjection: (
    tabId: string,
    window: Window
) => Popout_OnRemoveProjectionActionMessage = action(
    'Popout_OnRemoveProjection',
    (tabId: string, window: Window): Popout_OnRemoveProjectionActionMessage => ({
        tabId,
        window,
    })
);

export default onRemoveProjection;
